export default {
  employees: [],
  employeesCount: 0,
  query: '',
  limit: 10,
  skip: 0,
  sort: {}
}
